import Isotope from 'isotope-layout';
import React, { useEffect, useState } from 'react';
import PhotoGalleryItem from '../components/PhotoGalleryItem';


const PhotoGalleryHome = () => {
    const GalleryData = [
        {
            id: '1',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/1.jpg',
            tag: 'img-30 drinks'
        },
        {
            id: '3',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/3.jpg',
            tag: 'img-30 dessert'
        },
        {
            id: '4',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/4.jpg',
            tag: 'img-30 stake drinks'
        },
        {
            id: '5',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/5.jpg',
            tag: 'img-30 stake coffee'
        },
        {
            id: '7',
            category: 'Drinks',
            itemName: 'Coffee Dalgona',
            img: 'images/portfolio/6.jpg',
            tag: 'img-30 drinks'
        },

    ];

    const [filterKey, setFilterKey] = useState('*')

    // initialize an Isotope object with configs
    useEffect(() => {
        Isotope.current = new Isotope('.grid-masonary', {
            layoutMode: 'fitRows',
            itemSelector: '.grid-item ',
            percentPosition: true,
            transformsEnabled: true,
            transitionDuration: "700ms",
            fitWidth: true,
            columnWidth: '.grid-sizer',
        })
        // cleanup
        return () => Isotope.current.destroy()
    }, [])

    // handling filter key change
    useEffect(() => {
        filterKey === '*'
            ? Isotope.current.arrange({ filter: `*` })
            : Isotope.current.arrange({ filter: `.${filterKey}` })
    }, [filterKey]);

    const handleFilterKeyChange = key => () => setFilterKey(key)


    return (
        <div className="container">
            <div className="section_header">
                <img src="images/title_back.png" alt="" />
                <h2 className="section_title">Photo Gallery</h2>
                <h6 className="section_sub_title">
                    Learn our history see our glorious journey as a restaurant
                </h6>
            </div>
            <div className="portfolio_grid">
                <div className="grid-masonary gutter-15 clearfix">
                    <div className="grid-sizer"></div>
                    {
                        GalleryData.map(data => <PhotoGalleryItem
                            key={data.id}
                            data={data}
                        />)
                    }
                </div>
            </div>
        </div>
    );
};

export default PhotoGalleryHome;